import RentalTag from './RentalTag';

export default RentalTag;
